const WALKIN_BOOKING_HANDOFF_KEY = 'clinicWalkin.latestBookingHandoff'

export function saveClinicWalkinBookingHandoff(data) {
  try {
    sessionStorage.setItem(
      WALKIN_BOOKING_HANDOFF_KEY,
      JSON.stringify({
        ...data,
        savedAt: new Date().toISOString(),
      }),
    )
  } catch {
    // Session storage is best-effort; booking success should never depend on it.
  }
}

export function readClinicWalkinBookingHandoff() {
  try {
    const raw = sessionStorage.getItem(WALKIN_BOOKING_HANDOFF_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function clearClinicWalkinBookingHandoff() {
  try {
    sessionStorage.removeItem(WALKIN_BOOKING_HANDOFF_KEY)
  } catch {
    // no-op
  }
}
